import "./about-banner.css";

const AboutBanner = () => (
  <div className="about-banner">
    <div className="about-banner__inner">
      <p className="about-banner__title">
        <span>대한민국 외식산업을 이끄는</span>
        <span>식용유 유통 및 푸드서비스</span>
      </p>
    </div>
  </div>
);

export default AboutBanner;
